// Formata um campo que representa uma DATA pura (sem horário relevante —
// due_date, start_date, data de um changelog, etc). O bug clássico: sem
// timeZone: 'UTC', `new Date('2026-08-28').toLocaleDateString(...)` em um
// navegador no fuso do Brasil (UTC-3) mostra 27/08 em vez de 28/08, porque o
// JS interpreta a string como meia-noite UTC e o navegador exibe no fuso
// local. Use isto para qualquer data-only; para timestamps onde a hora
// importa (ex: "criado em 28/08/2026, 16:35"), mantenha o comportamento em
// fuso local — esse helper não serve para esse caso.
export function formatDateOnly(value, locale = 'pt-BR') {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
  });
}
